<template>
  <Modal c-class="bg-light-100 bg-important" :classs="mClass" @cancel="() => {}">
    <template #default>
      <div
        class="hover:bg-light-300 absolute !top-4 !right-4 flex !h-6 !w-6 cursor-pointer items-center justify-center rounded-[3px]"
        @click="close">
        <img src="../../modules/header/assets/icons/close_icon.svg" />
      </div>
      <div class="bg-light-100 flex w-[536px] flex-col items-center pt-1">
        <img class="w-[416px]" src="../../modules/header/assets/images/schedule_public_update_plan.png" />
        <div>
          <div class="text-light-mode-high-contrast !mt-8 !mb-4 !text-2xl font-semibold !leading-[120%]">
            Schedule publish your page with GemPages
          </div>
          <div class="text-light-mode-low-contrast !text-sm font-normal !leading-[22px]">
            Schedule posts will automatically publish pages for you - no notifications required & save you time.
          </div>

          <div class="text-light-mode-low-contrast mt-[22.3px] !text-sm font-normal !leading-[22px]">
            Schedule publish is available in <span class="text-light-mode-high-contrast font-medium">Optimize</span> and
            <span class="text-light-mode-high-contrast font-medium">Enterprise</span> plan.
          </div>
        </div>
        <div class="!mt-6 w-full">
          <ButtonBase class="!h-12 w-full" @click="openPricingPage">
            <span class="text-sm font-medium">Upgrade plan</span>
          </ButtonBase>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ButtonBase } from '@modules/common';
import goToPricing from '@/mixins/goToPricing';

export default defineComponent({
  components: {
    ButtonBase,
  },
  mixins: [goToPricing],
  props: {
    mClass: String,
  },
  methods: {
    close() {
      this.$emit('cancel');
    },

    openPricingPage() {
      //TRUONGNC-LINK HERE
      this.goToPricing();
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(.gp_modal-container_body) {
  padding: 0 29px 32px !important;
}

.btn {
  width: 120px;
}

.font-weight {
  &--500 {
    font-weight: 500;
  }
}
</style>
